import cx from 'classnames';
import React from 'react';

import {FontVariant, Text} from '@pexip/components';

import styles from './PresenterLabel.module.scss';

export const PresenterLabel: React.FC<{text: string; className?: string}> = ({
    text,
    className,
}) => (
    <div className={cx(styles.presenterLabel, className)}>
        <Text className={styles.text} fontVariant={FontVariant.XSmall}>
            {text}
        </Text>
    </div>
);
